import { UserEnergySettings } from './types';

/**
 * Parse time string in format "HH:MM" to hours as number (e.g., "07:30" -> 7.5)
 * @param timeStr Time string in format "HH:MM"
 * @returns Hours as number with decimal part for minutes
 */
export function parseTimeToHours(timeStr: string): number {
  if (!timeStr || typeof timeStr !== 'string') {
    return 7; // Default to 7:00 AM
  }

  const parts = timeStr.split(':');
  if (parts.length !== 2) {
    return 7; // Default if format is incorrect
  }

  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);

  if (isNaN(hours) || isNaN(minutes)) {
    return 7; // Default if parsing fails
  }

  return hours + (minutes / 60);
}

/**
 * Get default user energy settings
 * @returns Default user energy settings
 */
export function getUserEnergySettings(): UserEnergySettings {
  return {
    wakeTime: "07:00",  // 7:00 AM
    sleepTime: "23:00", // 11:00 PM
  };
}

/**
 * Calculate sleep duration based on wake and sleep times
 * @param wakeTime Wake time string in format "HH:MM"
 * @param sleepTime Sleep time string in format "HH:MM"
 * @returns Sleep duration in hours
 */
export function calculateSleepDuration(wakeTime: string, sleepTime: string): number {
  const wakeHours = parseTimeToHours(wakeTime);
  const sleepHours = parseTimeToHours(sleepTime);

  // Assuming sleep time is in the evening and wake time is in the morning of the next day
  if (sleepHours > wakeHours) {
    return (24 - sleepHours) + wakeHours;
  } else {
    // Unusual case where sleep time is after midnight or wake time is in the evening
    return wakeHours - sleepHours;
  }
}
